import { defineMessages } from 'react-intl';

export default defineMessages({
  saveButton: {
    id: 'common.buttons.save',
    defaultMessage: 'Save',
  },
  cancelEditing: {
    id: 'common.buttons.cancelEditing',
    defaultMessage: 'Cancel editing',
  },
});
